"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldLabel = FieldLabel;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function FieldLabel(props) {
  var labelClass = props.disabled ? 'label label--small label--disabled' : 'label label--small';
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: labelClass
  }, props.children);
}

FieldLabel.propTypes = {
  children: _propTypes["default"].node.isRequired,
  disabled: _propTypes["default"].bool
};
FieldLabel.defaultProps = {
  disabled: false
};